// Narrative order is source order, independent of graph topology and coordinates.
export function narrativeTrack(document) {
  let duration = 0
  const chapters = new Map(document.chapters.map((chapter) => [chapter.id, chapter]))
  const segments = document.paragraphs
    .filter((p) => p.kind === 'paragraph')
    .map((paragraph, index) => {
      const start = duration
      // Longer paragraphs get a little more time; this is a visual tour, not a reading timer.
      duration += Math.max(1800, Math.min(6000, [...paragraph.text].length * 12))
      return {
        id: paragraph.id,
        index,
        chapterId: paragraph.chapterId,
        chapter: chapters.get(paragraph.chapterId),
        start,
        end: duration,
        label: paragraph.id.replace(/^P0+(?=\d)/, 'P'),
        title: paragraph.display_label || paragraph.id,
      }
    })
  return { segments, duration }
}

export function narrativeIndex(segments, position) {
  if (!segments.length) return -1
  const index = segments.findIndex((segment) => position < segment.end)
  return index === -1 ? segments.length - 1 : index
}
